module.exports = __webpack_public_path__ + "static/media/share-icon.fca64323.svg";